"use client";

import { useEffect, useEffectEvent } from "react";
import Cookies from "js-cookie";
import { fxExperimentCookie, parseFxExperiment } from "~/lib/flags/fxFlagCookie";
import { trackFxImpression } from "~/lib/optimizely/trackFxEvent";
import { sendAbTestEvent } from "~/lib/optimizely/sendAbTestEvent";
import { useUnauthorizedEventService } from "~/services/api/services/event";

// ab_test goes to GTM and BigQuery once per session per variation.
const AB_TEST_SENT_KEY = "fx-ab-test-sent";

function isFirstInSession(key: string): boolean {
    try {
        if (sessionStorage.getItem(key)) {
            return false;
        }

        sessionStorage.setItem(key, "1");
    } catch {
        // Storage unavailable: send rather than drop the event.
    }

    return true;
}

export default function FxImpressions({ flagKeys }: { flagKeys: string[] }) {
    const sendBigQueryEvent = useUnauthorizedEventService();

    const sendImpressions = useEffectEvent(() => {
        for (const flagKey of flagKeys) {
            const experiment = parseFxExperiment(Cookies.get(fxExperimentCookie(flagKey)));

            if (experiment) {
                const { experimentId, variationId } = experiment;

                if (isFirstInSession(`${AB_TEST_SENT_KEY}:${experimentId}.${variationId}`)) {
                    sendAbTestEvent(sendBigQueryEvent, experimentId, variationId);
                }

                trackFxImpression(flagKey);
            }
        }
    });

    useEffect(() => {
        sendImpressions();
    }, []);

    return null;
}
